import React from 'react';
import { RuleInput, useSecuredDecoration } from './securedDecoration';

interface ComponentProps {
  id: string;
  /** Which one of a repeated area this is (row id, field key…) — see SecuredConfig.instance. */
  instance?: string;
  visible?: RuleInput;
  editable?: RuleInput;
  label?: string;
  /** What the section is and whose it is — see SecuredConfig.description. */
  description?: string;
  /** See SecuredConfig.note. */
  note?: string;
  children: React.ReactNode;
}

const SecuredArea: React.FC<ComponentProps> = ({ id, instance, visible, editable, label, description, note, children }) => {
  const { decorate } = useSecuredDecoration({ id, instance, visible, editable, label, description, note });
  return <>{decorate(children)}</>;
};

export default SecuredArea;